import axiosInstance from '../services/AxiosInstance';

export function getBoxFolders(id = '0', key) {
  return axiosInstance.post(`box/folders`, { id: id, key: key });
}

export function getBoxAuthToken(key) {
  return axiosInstance.post(`box/token`, { key: key });
}

export function uploadFile(data) {
  return axiosInstance.post(`box/upload`, data);
}

export function uploadFileBatch(data) {
  return axiosInstance.post(`box/upload-batch`, data);
}

export function getUsersSearch(search = '') {
  return axiosInstance.get(`box/azure-user?search=${search}`);
}

export function getBoxAuthUrl(redirect_uri = '') {
  return axiosInstance.post(`box/box-auth-url`, { redirect_uri: redirect_uri });
}

export function boxFileCount(data) {
  return axiosInstance.post(`box/boxFileCount`, data, {
    timeout: 600000, // 600000 ms = 10 minutes
  });
}

export function boxDSOContracts(data) {
  return axiosInstance.post(`box/boxDSOContracts`, data, {
    timeout: 600000, // 600000 ms = 10 minutes
  });
}

export function getDSOFolders(data) {
  return axiosInstance.post(`box/getDSOFolders`, data, {
    timeout: 600000, // 600000 ms = 10 minutes
  });
}

export function boxFormFileCount(data) {
  return axiosInstance.post(`box/boxFormFileCount`, data, {
    timeout: 600000, // 600000 ms = 10 minutes
  });
}

export function getContractsByName(data) {
  return axiosInstance.post(`box/getContractsByName`, data, {
    timeout: 600000, // 600000 ms = 10 minutes
  });
}
